<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!windowService?.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [noBow]="true"
      [title]="'Remove Employee'" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav; context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    <ng-container *ngTemplateOutlet="topNav; context:{ extraClass: 'desktop' }" />

    @if (windowService?.isDesktopRes) {
      <tidy-row [align]="'center'" class="extra-bottom-padding">
        <tidy-text [title]="'Remove Employee'" />
      </tidy-row>
    }

    <tidy-row [align]="'center'" class="extra-bottom-padding">
      <tidy-text
        [body]="employeeName ? ('Are you sure you want to remove ' | translate) + employeeName + ('? This action cannot be undone.' | translate) : 'Are you sure you want to remove this employee? This action cannot be undone.'" />
    </tidy-row>

    <tidy-two-column-row>
      <tidy-button
        text="Cancel"
        [action]="boundCancel"
        class="secondary" />
      <tidy-button
        text="Remove Employee"
        [action]="boundConfirm"
        class="primary" />
    </tidy-two-column-row>

  </tidy-wrapper>
</ng-template>

<app-scroll-wrapper [templateContent]="content" />
